<template>
    <el-dialog :title="showTitle" :visible.sync="showFlag" :close-on-click-modal="false">
        <div class="error-main">
            <div class="error-child" v-for="ele in datas" :key="ele.msg"><strong>{{ele.msg}}</strong>
            </div>
        </div>
        <el-row class="margin-top-20" style="text-align: right;">
            <el-button  @click="closeDialog" style="margin: 0 20px;" :size="GLOBAL.config.systemSize">关闭</el-button>
        </el-row>
    </el-dialog>
</template>

<script>
export default {
    name: "GCArchivesInfoImportErrorDialog",

    data() {
        return{
            showTitle: '',
            showFlag: false,
            datas: []
        }
    },

    methods: {
        open(datas, title) {
            let _this = this;
            _this.showTitle = title;
            _this.datas = datas;
            _this.showFlag = true;
        },
        closeDialog() {
            this.showFlag = false;
        },
    }
}
</script>

<style scoped>
    .error-main {
        height:180px;width:100%;overflow-y: scroll;
    }
    .error-child{
        margin-top:10px;padding-left:50px;color:#F56C6C;
    }
</style>


// WEBPACK FOOTER //
// src/view/GCArchivesInfo/GCArchivesInfoImportErrorDialog.vue